// AdUnit.tsx
import React, { useEffect, useRef, CSSProperties } from 'react';

declare global {
  interface Window {
    adsbygoogle?: unknown[];
  }
}

interface AdUnitProps {
  slot: string;
  format?: string;
  client: string;
  style?: CSSProperties;
}

const AdUnit: React.FC<AdUnitProps> = ({
  slot,
  format = 'auto',
  client,
  style,
}) => {
  const insRef = useRef<HTMLModElement>(null);

  useEffect(() => {
    const ins = insRef.current;
    if (!ins) return;

    // If we've already rendered into this <ins>, skip
    if (ins.getAttribute('data-ads-rendered') === 'true') {
      return;
    }

    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      // mark it so we don't push again
      ins.setAttribute('data-ads-rendered', 'true');
    } catch (e) {
      // normally you’d log, but silence “already have ads” errors
      console.warn('AdSense push error (probably OK):', e);
    }
  }, []);

  return (
    <ins
      ref={insRef}
      className="adsbygoogle"
      style={style ?? { display: 'block' }}
      data-ad-client={client}
      data-ad-slot={slot}
      data-ad-format={format}
      //data-ad-format="" 
      //data-full-width-responsive="false"
    />
  );
};

export default AdUnit;
